<script lang="ts">
    import {lastSeenCinema} from "./LastSeenCinema";
    import {suggestType} from "../../../store/Derived";
    import {SuggestType} from "../../../constants/suggestType";
    import {RECO_CORE_EVENT} from "../../../events/recoCoreEvents";
    import {SQRL_EVENT} from "../../../events/sqrlEvents";
    import {tracking} from "../../../tracking/Tracking";
    import {onCinemaShown} from "../../../index";

    /**
 *
 *
 *
 *
 */
    function renderLastSeenCinema(node: HTMLElement) {
        node.appendChild(lastSeenCinema.template);
        if (!lastSeenCinema.hasContent) {
            return;
        }
        lastSeenCinema.trackLoadOnce(() => {
            window.o_global.events().once(RECO_CORE_EVENT.REGISTERED_CINEMA, (id: string) => {
                if (id === "squirrel_last_seen_cinema_wrapper") {
                    tracking.trackCreateEventContext(SQRL_EVENT.CINEMA_SHOWN, onCinemaShown);
                }
            });
            window.o_global.events().emit(RECO_CORE_EVENT.REGISTER_CINEMA, "squirrel_last_seen_cinema_wrapper");
        });
    }
</script>

<div
        class="js_squirrel_lastSeenCinema"
        class:hidden={($suggestType !== SuggestType.HYBRID && $suggestType !== SuggestType.TRENDING_QUERY) || !lastSeenCinema.hasContent}
>
    <div class="js_squirrel_lastSeenCinemaWrapper" use:renderLastSeenCinema></div>
</div>

<style lang="scss">
  @use "@otto-ec/design-tokens/tokens";

  .js_squirrel_lastSeenCinema {
    background-color: tokens.$oc-base-color-white;

    &.hidden {
      display: none;
    }
  }
</style>
